/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SearchProductResultFromJSON, SearchProductResultToJSON, } from './SearchProductResult';
/**
 * Check if a given object implements the ProductPaginationResult interface.
 */
export function instanceOfProductPaginationResult(value) {
    let isInstance = true;
    return isInstance;
}
export function ProductPaginationResultFromJSON(json) {
    return ProductPaginationResultFromJSONTyped(json, false);
}
export function ProductPaginationResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'rows': !exists(json, 'rows') ? undefined : (json['rows'].map(SearchProductResultFromJSON)),
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'totalRows': !exists(json, 'totalRows') ? undefined : json['totalRows'],
    };
}
export function ProductPaginationResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'limit': value.limit,
        'page': value.page,
        'rows': value.rows === undefined ? undefined : (value.rows.map(SearchProductResultToJSON)),
        'totalPages': value.totalPages,
        'totalRows': value.totalRows,
    };
}
